import React, {ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import {Annotation, MetadataRectangle} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class LinkAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let href: string = "#";

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 popupContent={annotation.contents} creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				<a style={{display: "block", width: rectBoundaries.width, height: rectBoundaries.height}}
				   href={href} target="_blank" rel="noreferrer">
				</a>
			</AnnotationRectangle>
		);
	}
}